import CityPageTemplate from "../city-template/CityPageTemplate";
import { gilletteConfig } from "./data";

export default function GillettePage() {
  return <CityPageTemplate config={gilletteConfig} />;
}